<template>
  <v-card class="d-flex align-items-center text-center mt-4">
    <div class="w-100">
      <v-card-title class="card-title">
        Datos Laborales
      </v-card-title>
      <v-card-text>
        <v-row class="pa-3">
          <v-col cols="12" md="4">
            <BaseCombobox label="Sucursal*" name="sucursal" v-model="legajo.sucursal" :items="sucursales"
              item-text="name" item-value="id" :loading="loading_sucursales" :rules="'required|combobox_required'"
              :validationErrors="errors" />

            <BaseInput label="Referencia externa" name="external_reference" v-model="legajo.external_reference"
              :rules="''" :validationErrors="errors" />

            <BaseDatePicker v-if="legajo.id != 0" label="Fecha de baja" name="finish_date" v-model="legajo.finish_date"
              :rules="''" :validationErrors="errors" />
          </v-col>
          <v-col cols="12" md="4">
            <BaseCombobox label="Sector" name="worksector" v-model="legajo.worksector" :items="worksectors"
              item-text="name" item-value="id" :loading="loading_worksectors" :rules="'combobox'"
              :validationErrors="errors" />


            <BaseDatePicker label="Fecha de ingreso*" name="hire_date" v-model="legajo.hire_date" :rules="'required'"
              :validationErrors="errors" />

          </v-col>
          <v-col cols="12" md="4">
            <BaseCombobox label="Puesto" name="workstation" v-model="legajo.workstation" :items="workstations"
              item-text="name" item-value="id" :loading="loading_workstations" :rules="''" :validationErrors="errors" />
            <BaseDatePicker v-if="legajo.id != 0" label="Fecha de alta" name="creation_date"
              v-model="legajo.creation_date" :rules="''" :validationErrors="errors" />

          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import Constant from "@/constants/sections";

import { generalService } from "@/libs/ws/generalService";
import BaseInput from "@/components/BaseInput.vue";
import BaseCombobox from "@/components/BaseCombobox.vue";
import BaseDatePicker from "@/components/BaseDatePicker.vue";


export default {
  components: { BaseInput, BaseCombobox, BaseDatePicker },
  name: "CardPersonalWork",
  props: {
    legajo: {
      type: Object,
    }
  },
  data() {
    return {
      service: generalService,
      sucursales: [],
      worksectors: [],
      workstations: [],
      loading_sucursales: false,
      loading_worksectors: false,
      loading_workstations: false,
      menu_finish_date: false
    };
  },
  created() {

  },
  mounted() {
    this.loadSucursales();
    this.loadWorksectors();
    this.loadWorkstations();
  },
  methods: {
    async validate() {
      const valid = await this.$validator.validateAll();
      return valid;
    },
    loadSucursales() {
      this.loading_sucursales = true
      this.service.setSection(Constant.SECTION_SUCURSALES);
      this.service
        .filter({ enabled: true })
        .then((response) => {
          if (response.status)
            this.sucursales = response.result;

        })
        .catch((e) => {
          console.log("categories.filter error");
          console.log(e);

        })
        .finally(() => {
          this.loading_sucursales = false
        });
    },
    loadWorksectors() {
      this.loading_worksectors = true
      this.service.setSection(Constant.SECTION_WORKSECTORS);
      this.service
        .filter({ enabled: true })
        .then((response) => {
          if (response.status)
            this.worksectors = response.result;

        })
        .catch((e) => {
          console.log("categories.filter error");
          console.log(e);

        })
        .finally(() => {
          this.loading_worksectors = false
        });
    },
    loadWorkstations() {
      this.loading_workstations = true
      this.service.setSection(Constant.SECTION_WORKSTATIONS);
      this.service
        .filter({ enabled: true })
        .then((response) => {
          if (response.status)
            this.workstations = response.result;

        })
        .catch((e) => {
          console.log("categories.filter error");
          console.log(e);

        })
        .finally(() => {
          this.loading_workstations = false
        });
    }
  },
};
</script>
